// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__3Ry2_","insightsList":"newBusinessInsightsMenu_insightsList__36Rs_","active":"newBusinessInsightsMenu_active__284pC"};